import _ from 'lodash';
import React from 'react';

import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon as MuiListItemIcon,
  ListItemText as MuiListItemText,
  styled,
  TextField
} from '@mui/material';

import { DesktopMacOutlined, Search } from '@mui/icons-material';
import * as dataService from './dataService';


const ContainerBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#F6F8FC',
  minWidth: 240,
  paddingTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  overflowY: 'scroll'
}));

const ListItemIcon = styled(MuiListItemIcon, {})<{ selected: boolean; }>(({ theme, selected }) => ({
  color: selected ? theme.palette.primary.light : undefined
}));

const ListItemText = styled(MuiListItemText, {})<{ selected: boolean; }>(({ theme, selected }) => ({
  color: selected ? theme.palette.primary.light : undefined
}));



export interface IProps {
  storeId: string;
  selectedOrderId: string;
  onClickOrder: (orderId: string) => void;
}

export const FC: React.FC<IProps> = props => {
  const [fnQuery, tuple] = dataService.useQuery(props.storeId);



  React.useEffect(() => {
    fnQuery('');
  }, [fnQuery]);



  React.useEffect(() => {
    const func = function (ev: KeyboardEvent) {
      if (ev.code === 'BracketRight') {
        const currentIndex = _.findIndex(tuple.data.orders, order => order.id === props.selectedOrderId);
        if (currentIndex < tuple.data.orders.length - 1) {
          props.onClickOrder(tuple.data.orders[currentIndex + 1].id);
        }

      } else if (ev.code === 'BracketLeft') {
        const currentIndex = _.findIndex(tuple.data.orders, order => order.id === props.selectedOrderId);
        if (currentIndex > 0) {
          props.onClickOrder(tuple.data.orders[currentIndex - 1].id);
        }
      }
    };
    window.addEventListener('keydown', func);

    return () =>
      window.removeEventListener('keydown', func);
  }, [props, tuple.data.orders]);



  React.useEffect(() => {
    if (!props.selectedOrderId && !_.isEmpty(tuple.data.orders)) {
      const firstOrder = _.first(tuple.data.orders);
      props.onClickOrder(firstOrder?.id ?? '');
    }

  }, [tuple, props]);



  const handleChangeSearch = _.debounce((search: string) => {
    fnQuery(search);
  }, 500);



  const orderRows = React.useMemo(() => {
    return _.map(tuple.data.orders, order => (
      <ListItem
        key={order.id}
        disablePadding
        style={{
          backgroundColor: order.id === props.selectedOrderId ? "white" : undefined
        }}>
        <ListItemButton onClick={() => props.onClickOrder(order.id)}>
          <ListItemIcon selected={order.id === props.selectedOrderId}>
            <DesktopMacOutlined />
          </ListItemIcon>

          <ListItemText
            selected={order.id === props.selectedOrderId}
            primary={order.customerFullName}
            secondary={order.orderNumber} />
        </ListItemButton>
      </ListItem>
    ));
  }, [props, tuple.data.orders]);



  return (
    <ContainerBox>
      <TextField
        label="Search"
        placeholder="Search"
        InputProps={{
          startAdornment: <Search />
        }}
        onChange={ev => handleChangeSearch(ev.target.value)} />

      <List>
        {orderRows}
      </List>
    </ContainerBox>
  );
};
